import { render } from "./FileManager.vue?vue&type=template&id=7f18e3a6&scoped=true&ts=true"
import script from "./FileManager.vue?vue&type=script&lang=ts"
export * from "./FileManager.vue?vue&type=script&lang=ts"

import "./FileManager.vue?vue&type=style&index=0&id=7f18e3a6&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f18e3a6"]])

export default __exports__